import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { AppEnvironment, createModifyApiInterceptor } from 'config-data';

export function initializeApiRewriteInterceptors(apiRewrites: { [key: string]: string }, cfg: ApplicationConfig, env: AppEnvironment) {
  for (const [from, to] of Object.entries(apiRewrites)) {
    if (from !== to) {
      cfg.providers.push({
        provide: HTTP_INTERCEPTORS,
        useClass: createModifyApiInterceptor(from, to),
        multi: true,
      });
    }
  }
  cfg.providers.push(...env.providers);
}
